import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../../services/authService';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader';

const Login = () => {
    const {t} = useTranslation();
  const { register, handleSubmit, formState: { errors } } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {loader, errors:errosForm, isAuth} = useSelector((state) => state.auth);

  const onSubmit = (data) => {
        dispatch(loginUser(data))
    }

    useEffect(()=> {
        if(isAuth) {
            navigate('/user/Dashboard')
        }
    }, [dispatch, isAuth, navigate])

if(loader) return <Loader />

  return (
    <>
    {errosForm?.length > 0 && 
        <div className="flex justify-between py-4 px-8 bg-[#fad2e1]  text-[#7c193d]">
            <ul>
            {errosForm?.map((error, key) => <li key={key} className="font-medium">
                {error}
            </li>
            )}
            </ul>
        </div>
    }
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-700">{t('login.title')}</h2>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-600">{t('login.form.email.label')}</label>
            <input
              type="email"
                {...register("email", { 
                    required: t('login.form.email.required'), 
                    pattern: { 
                    value:  /^[^\s@]+@[^\s@]+\.[^\s@]+$/, 
                    message: t('login.form.email.message') 
                    }
                })}
              className="w-full px-4 py-2 text-gray-700 bg-gray-100 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
            />
            {errors.email && <p className="mt-1 text-sm text-red-500">{errors.email.message}</p>}
          </div>
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-600">{t('login.form.password.label')}</label>
            <input
              type="password"
                {...register("password", { 
                    required: t('login.form.email.required')
                })}
             
              className="w-full px-4 py-2 text-gray-700 bg-gray-100 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
            />
            {errors.password && <p className="mt-1 text-sm text-red-500">{errors.password.message}</p>}
          </div>
          <button
            type="submit"
            // disabled = {loader}
            className="w-full px-4 py-2 font-medium text-white bg-primaryColor rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
          >
            {t('login.form.button')}
           
          </button>
        </form>
      </div>
    </div>
    </>
  )
}

export default Login